export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ConnectDialog.json?hash=72a383072dc8b9d5b2a2fdf48e3d56ba";